import type { OrderItemDto, OrderOverviewMetricsDto } from './investorOverviewContracts'
import type { OrderItem, OrderOverviewMetrics } from '../types/investorOverviewTypes'

export const parseOrderOverviewMetrics = (dto: OrderOverviewMetricsDto): OrderOverviewMetrics => ({
  totalInvestmentValue: String(dto.total_investment_value ?? '0.00'),
  totalInvestors: Number(dto.total_investors ?? 0),
  totalTokensIssued: Number(dto.total_tokens_issued ?? 0),
  propertiesAwaitingTokenisation: Number(dto.properties_awaiting_tokenisation ?? 0),
})

export const parseOrderItem = (dto: OrderItemDto): OrderItem => ({
  id: String(dto.id ?? dto._id ?? ''),
  propertyId: String(dto.property_id ?? ''),
  propertyName: String(dto.property_name ?? ''),
  propertyImage: String(dto.property_image ?? ''),
  investorId: String(dto.investor_id ?? ''),
  investorName: String(dto.investor_name ?? ''),
  tokens: Number(dto.tokens ?? 0),
  investmentValue: String(dto.investment_value ?? '0.00'),
  status: String(dto.status ?? 'pending'),
  orderDate: String(dto.order_date ?? ''),
})
